import React, { useState, useContext, useEffect } from "react";
import { Spinner, Button, Card, Row, Col } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";
import { toast } from "react-hot-toast";
import PsContext from "../../../context/PsContext";
import API from "../../../utils/API";
import { Api } from "../../../utils/Variables";

const OrderStatus = (props) => {
  const context = useContext(PsContext);
  const [loading, setLoading] = useState(true);
  const [repayLoader, setRepayLoader] = useState(false);
  const [orderUid] = useState(props.match.params.uid);
  const [orderData, setOrderData] = useState([]);
  const [reqData, setReqData] = useState(null);
  const [accessCode, setAccessCode] = useState(null);

  const loadOrderData = () => {
    setLoading(true);
    API.get(`v1/site/getorderbyid/${orderUid}`).then((res) => {
      if (res.data.status === "1") {
        setOrderData(res.data.data);
      }
      setLoading(false);
    });
  };

  const repayClick = () => {
    setRepayLoader(true);
    API.get(`v1/site/repayment/${orderUid}`).then((res) => {
      if (res.data.status === "1") {
        setReqData(res.data.reqdata);
        setAccessCode(res.data.access_code);
        document.getElementById("frmCcPay").submit();
      } else {
        toast.error(res.data.message, {
          style: {
            marginTop: "5%",
            borderRadius: "4px",
            background: "#333",
            color: "#fff",
          },
        });
        setRepayLoader(false);
      }
    });
  };

  useEffect(() => {
    loadOrderData();
  }, []);

  const groupByOrderId = (orders) => {
    const grouped = {};
    orders.forEach((item) => {
      if (!grouped[item.orderid]) {
        grouped[item.orderid] = {
          orderid: item.orderid,
          orderdate: item.orderdate,
          orderstatus: item.orderstatus,
          items: [],
          totalprice: 0,
        };
      }
      grouped[item.orderid].items.push(item);
      grouped[item.orderid].totalprice += parseFloat(item.totalprice);
    });
    return Object.values(grouped);
  };

  return (
    <>
      <div className="tf-page-title mb-50">
        <div className="container-full text-center">
          <div className="heading">Order Status</div>
          <p className="text-2 text_black-2 mt_5">
            Check your order details and status
          </p>
        </div>
      </div>

      <div className="container mb-5">
        <Row className="justify-content-center">
          <Col md={12}>
            <Card className="shadow-sm border-0">
              <Card.Body>
                {loading ? (
                  <div className="text-center py-5">
                    <div className="ps_round_loader mb-3"></div>
                    <div>Loading order information...</div>
                  </div>
                ) : orderData.length > 0 ? (
                  <div className="my-account-content account-order">
                    <div className="wrap-account-order">
                      <table
                        className="table table-hover"
                        style={{ fontSize: "14px" }}
                      >
                        <thead>
                          <tr>
                            <th className="fw-bold">Order ID</th>
                            <th className="fw-bold">Date</th>
                            <th className="fw-bold">Products</th>
                            <th className="fw-bold">Status</th>
                            <th className="fw-bold">Total</th>
                            <th className="fw-bold">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {groupByOrderId(orderData).map((order, index) => (
                            <tr key={index}>
                              <td style={{ verticalAlign: "middle" }}>
                                {order.orderid}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {order.orderdate}
                              </td>
                              <td>
                                <div className="d-flex flex-wrap">
                                  {order.items.map((prod, i) => (
                                    <img
                                      key={i}
                                      src={`${Api.CloudImageUrl}/${prod.image}`}
                                      style={{
                                        height: "60px",
                                        marginRight: "5px",
                                        marginBottom: "5px",
                                      }}
                                      alt="product"
                                    />
                                  ))}
                                </div>
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                <span
                                  className={`badge ${
                                    order.orderstatus === "Payment pending"
                                      ? "bg-warning"
                                      : "bg-success"
                                  }`}
                                >
                                  {order.orderstatus}
                                </span>
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                ₹{order.totalprice.toFixed(2)} for{" "}
                                {order.items.length}{" "}
                                {order.items.length === 1 ? "item" : "items"}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {order.orderstatus === "Payment pending" ? (
                                  <Button
                                    variant="dark"
                                    size="sm"
                                    className="rounded-0"
                                    disabled={repayLoader}
                                    onClick={repayClick}
                                  >
                                    {repayLoader ? (
                                      <>
                                        <Spinner
                                          as="span"
                                          animation="border"
                                          size="sm"
                                          role="status"
                                          aria-hidden="true"
                                        />
                                        &nbsp; Please wait...
                                      </>
                                    ) : (
                                      "Repay Now"
                                    )}
                                  </Button>
                                ) : (
                                  <>
                                    <Link
                                      to={`/user/order-details/${order.orderid}`}
                                      className="tf-btn btn-fill animate-hover-btn rounded-0 btn-sm"
                                    >
                                      <span>View</span>
                                    </Link>
                                    <a
                                      href={`https://shibanifashion.com/site/storage/invoices/invoice_${order.orderid}.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="btn btn-outline-secondary btn-sm ms-2 rounded-0"
                                      download
                                    >
                                      <i className="fa fa-download me-1"></i>{" "}
                                    </a>
                                  </>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="text-center text-muted py-5">
                    <h5>No order details found.</h5>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Hidden CCAvenue Form */}
      <form
        action="https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction"
        method="post"
        name="redirect"
        id="frmCcPay"
      >
        <input type="hidden" name="encRequest" value={reqData} />
        <input type="hidden" name="access_code" value={accessCode} />
      </form>
    </>
  );
};

export default withRouter(OrderStatus);
